import request from '@/utils/request'

export function getSysModule(id) {
  return request({
    method: 'get',
    url: `${window.context.portal}/sys/sysModule/v1/getJson?id=${id}`,
  })
}
